import $ from 'jquery';

var Orders = {

    init: function () {
        this.showProductSelect();
        this.insertProducsRow();
        this.addProduct();
        this.showFilePath();
        this.importProductsByFileStatusHandler();
    },

    showProductSelect: function() {
        $('.product-select').on('input', function(e){
            $('.fast-order-form__select-product-wrapper').show();
        });
    },

    insertProducsRow: function() {
        $('.product').click(function(e){
            e.preventDefault();

            $('.fast-order-form__row--add-product').before('<tr class="fast-order-form__row"><td><input type="text" name="" value="'+ $(this).find('.product__number').text() +'" class="product-number" /></td><td>'+ $(this).find('.product__number').text() +'</td><td>'+$(this).find('.product__name').text()+'</td><td><input type="number" name="" value="134.45" class="product-quantity" /></td><td>бр.</td><td>1250.20 лв</td><td>5%</td><td>1250.20 лв</td><td><span class="product-status-expected">очакван на 22.02.2020</span></td><td><a href="" title="изтрий" class="product-delete">изтрий</a></td></tr>');
            $(this).parents('.fast-order-form__select-product-wrapper').hide();
            $(this).parents('.fast-order-form__row--add-product').hide();
            $('.product-select').val('');
        });
    },

    addProduct: function() {
        $('.fast-order-form__add-product-btn').click(function(e) {
            e.preventDefault();

            $('.fast-order-form__row--add-product').show();
        });
    },

    showFilePath: function() {
        $('#file-upload').change(function() {
            $('#file-upload-mask').val($(this).val());
            if($(this).val() !== '') {
                $('#btn-import-file-submit').prop('disabled', false);
            } else {
                $('#btn-import-file-submit').prop('disabled', true);
            }

        });
    },

    importProductsByFileStatusHandler: function() {
        $('#fast-order-file-import').submit(function() {
            $(this).find('.fast-order-form__status-info').removeClass('d-none');
            $('#btn-import-file-submit').prop('disabled', true);
        })
    }
}

export default Orders;
